<template lang="html">
  <CardLayout
    v-bind="$attrs"
    :item="item"
    :compact="!counts"
    v-on="$listeners"
  >
    <template #default>
      <IxRes>masterData.crops.usage.{{ item.id }}_name</IxRes>
    </template>
    <template #description>
      <IxRes v-if="count === 1" :context="{0: count}">
        masterData.crops.navigation.count_qualities_singular
      </IxRes>
      <IxRes v-else :context="{0: count}">
        masterData.crops.navigation.count_qualities_plural
      </IxRes>
    </template>
  </CardLayout>
</template>

<script>

import CardLayout from '../shared/CardLayout'

export default {
  components: {
    CardLayout
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    counts: Object
  },
  computed: {
    count () {
      return this.counts.quality
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
